import { MeasurementSystem } from '../types/MeasurementSystem';
import { MetricConverter } from './helpers';

const MassMetricUnits = ['mg', 'g', 'kg'] as const;
const MassImperialUnits = ['lb'] as const;
export const MassUnits = [...MassMetricUnits, ...MassImperialUnits] as const;

type TMassMetricUnit = (typeof MassMetricUnits)[number];
type TMassImperialUnit = (typeof MassImperialUnits)[number];
type TMassUnit = (typeof MassUnits)[number];

type MassUnitForSystem<MSystem extends MeasurementSystem> = MSystem extends MeasurementSystem.METRIC
    ? TMassMetricUnit
    : MSystem extends MeasurementSystem.IMPERIAL
      ? TMassImperialUnit
      : never;

export class MassConverter<MSystem extends MeasurementSystem> extends MetricConverter<TMassUnit, 'kg'> {
    baseUnit = 'kg' as const;
    units = MassUnits;
    system: MSystem;

    constructor(measurementSystem: MSystem) {
        super();

        this.system = measurementSystem;
    }

    getMultiplier(unit: TMassUnit) {
        switch (unit) {
            case 'mg':
                return 1e-6;
            case 'g':
                return 1e-3;
            case 'kg':
                return 1;
            case 'lb':
                return 0.45359237;
        }
    }

    getDisplayUnits(): MassUnitForSystem<MSystem>[] {
        switch (this.system) {
            case MeasurementSystem.METRIC:
                return [...MassMetricUnits] as MassUnitForSystem<MSystem>[];
            case MeasurementSystem.IMPERIAL:
                return [...MassImperialUnits] as MassUnitForSystem<MSystem>[];

            default:
                throw new Error('Invalid measurement system');
        }
    }
}
